import { useEffect } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { trackLandingPageView } from '../../api/track';

export function useTrackView(slug: string): void {
	const track = useTracking();

	useEffect(() => {
		void trackLandingPageView(slug, track);
	}, [slug, track]);
}
